import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72621182"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }

import {
  useNotificationItem,
  useNotifications,
} from "../composition/use-notifications";
import { UserNotification } from "../types/user-notifications-interface";
import { PropType } from "vue";
import BaseTypography from "@/ui-library/base-typography/base-typography.vue";
import BaseListItem from "@/ui-library/base-list-item/base-list-item.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'notification-dropdown-list-item',
  props: {
  notification: {
    type: Object as PropType<UserNotification>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const { handleNotificationClick } = useNotifications();

const { notificationIcon, notificationText } = useNotificationItem(
  props.notification
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseListItem, {
    class: _normalizeClass([{ read: __props.notification.read, unread: !__props.notification.read }, "notification-drop-down-list-item"]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(handleNotificationClick)(props.notification)))
  }, {
    default: _withCtx(() => [
      (_unref(notificationIcon))
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(notificationIcon))))
          ]))
        : _createCommentVNode("", true),
      _createVNode(BaseTypography, {
        spacer: "",
        subtitle3: "",
        class: "notification-message-text"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(notificationText)), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})